<div class=" o-modal--medium" id="mod-ap-req" style="width: 100%;">
    <div class="o-modal__head u-pt10 u-pb10">
        <a class="o-modal__close close-modal" matDialogClose></a>
        <label class="o-title o-title--white o-title--medium">{{ 'modalError.title' | translate}}</label>
    </div>

    <div class="o-modal__body u-pt0 u-mb40">
        <div class="col-md-12">
            <div class="col-md-12" align=center>
                <svg width="3em" height="3em" viewBox="0 0 16 16" class="bi bi-x-circle-fill" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM5.354 4.646a.5.5 0 1 0-.708.708L7.293 8l-2.647 2.646a.5.5 0 0 0 .708.708L8 8.707l2.646 2.647a.5.5 0 0 0 .708-.708L8.707 8l2.647-2.646a.5.5 0 0 0-.708-.708L8 7.293 5.354 4.646z"/>
                </svg>
            </div>
            
            <div class="col-md-12" align=center>
                <label>{{ 'modalError.body' | translate}}</label>
            </div>
            <div class="col-md-12" align=center>
                <label></label>
            </div>
        </div>
    </div>
</div>